import { Form, Input, InputMask } from '@mairistem/composants';

interface PosteComptableContactListItemFormProps {
  telephone: string;
  mail: string;
  onChange: (e) => void;
}

const PosteComptableContactListItemForm = (props: PosteComptableContactListItemFormProps) => {
  const { telephone, mail, onChange } = props;

  return (
    <Form
      // @ts-expect-error
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Form.Field>
        <label>Téléphone</label>
        <InputMask
          data-testid="form-input-telephone"
          // @ts-expect-error
          name="telephone"
          mask="99 99 99 99 99"
          value={telephone || ''}
          icon={{ name: 'phone' }}
          onChange={onChange}
          style={{ width: 175 }}
        />
      </Form.Field>
      <Form.Field
        label="Courriel"
        data-testid="form-input-mail"
        type="email"
        icon="mail"
        name="mail"
        value={mail}
        // @ts-expect-error
        control={Input}
        onChange={onChange}
      />
    </Form>
  );
};

export default PosteComptableContactListItemForm;
